export default __webpack_public_path__ + "static/media/need copy.7e6f6167.png";